import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.qa.onyxcentersource.com',
  hostname: 'pioneer.qa.onyxcentersource.com',
  portalUrl: 'https://portal.qa.onyxcentersource.com',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.qa.onyxcentersource.com',
  emailValidation: true,
  allowApiDocs: true,
  cwr: {
    enable: true
  },
  agencyDashboardUrl: 'https://agency-dashboard.qa.onyxcentersource.com',
  showAgencyDashboard: false
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.qa.ts